import { AxiosResponse } from "axios";
import axiosInstance from "../../api/axios";

export const getMe = async (token: string) => {
    try {
        const response: AxiosResponse<any> = await axiosInstance.post(
            "/auth/me",
            {
                token: token,
            }
        );
        console.log("Login successful:", response.data);
        return {
            data: response.data,
            success: true
        };
    } catch (error: any) {
        console.error("Login failed:", error.response?.data || error.message);
        // Handle failure (e.g., show an error message)
        return {
            data: error.response?.data,
            success: false,
        };
    }
}